import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import { ProtectedRoute } from "../components/auth/ProtectedRoute";

// Pages - Lazy Loaded
const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const Blog = lazy(() => import("../pages/artigos/page"));
const Servicos = lazy(() => import("../pages/servicos/page"));
const Workshops = lazy(() => import("../pages/workshops/page"));
const Podcast = lazy(() => import("../pages/podcast/page"));
const Conteudo = lazy(() => import("../pages/conteudo/page"));
const Empresas = lazy(() => import("../pages/empresas/page"));
const NaMidia = lazy(() => import("../pages/na-midia/page"));
const Meditacao = lazy(() => import("../pages/meditacao/page"));
const Links = lazy(() => import("../pages/links/page"));
const ConteudoVIP = lazy(() => import("../pages/conteudo-vip/page"));
const CadastroVIP = lazy(() => import("../pages/cadastro-vip/page"));
const RedefinirSenhaVIP = lazy(() => import("../pages/conteudo-vip/redefinir-senha/page"));

// Admin - Lazy Loaded
const AdminLogin = lazy(() => import("../pages/admin/login/page"));
const AdminDashboard = lazy(() => import("../pages/admin/dashboard/page"));
const AdminSettings = lazy(() => import("../pages/admin/settings/page"));
const AdminBanners = lazy(() => import("../pages/admin/banners/page"));
const AdminCompanies = lazy(() => import("../pages/admin/companies/page"));
const AdminArticles = lazy(() => import("../pages/admin/articles/page"));
const AdminMeditations = lazy(() => import("../pages/admin/meditations/page"));
const AdminPodcasts = lazy(() => import("../pages/admin/podcasts/page"));
const AdminMedia = lazy(() => import("../pages/admin/media/page"));
const AdminCorporateServices = lazy(() => import("../pages/admin/corporate-services/page"));
const AdminPersonalServices = lazy(() => import("../pages/admin/personal-services/page"));
const AdminTestimonials = lazy(() => import("../pages/admin/testimonials/page"));
const AdminLeads = lazy(() => import("../pages/admin/leads/page"));
const AdminOverview = lazy(() => import("../pages/admin/dashboard/Overview"));
const AdminVIPUsers = lazy(() => import("../pages/admin/vip-users/page"));
const AdminVIPContent = lazy(() => import("../pages/admin/vip-content/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/conteudo-vip",
    element: <ConteudoVIP />,
  },
  {
    path: "/conteudo-vip/redefinir-senha",
    element: <RedefinirSenhaVIP />,
  },
  {
    path: "/conteudo-vip/:slug",
    element: <ConteudoVIP />,
  },
  {
    path: "/cadastro-vip",
    element: <CadastroVIP />,
  },
  {
    path: "/conteudo/artigos",
    element: <Blog />,
  },
  {
    path: "/conteudo/artigos/:slug",
    element: <Blog />,
  },
  {
    path: "/para-voce",
    element: <Servicos />,
  },
  {
    path: "/workshops",
    element: <Workshops />,
  },
  {
    path: "/conteudo/podcast",
    element: <Podcast />,
  },
  {
    path: "/conteudo",
    element: <Conteudo />,
  },
  {
    path: "/conteudo/na-midia",
    element: <NaMidia />,
  },
  {
    path: "/conteudo/na-midia/:slug",
    element: <NaMidia />,
  },
  {
    path: "/conteudo/meditacao",
    element: <Meditacao />,
  },
  {
    path: "/empresas",
    element: <Empresas />,
  },
  {
    path: "/links",
    element: <Links />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <ProtectedRoute />,
    children: [
      {
        path: "",
        element: <AdminDashboard />,
        children: [
          {
             path: "",
             element: <AdminOverview />
          },
          {
             path: "settings",
             element: <AdminSettings />
          },
          {
             path: "banners",
             element: <AdminBanners />
          },
          {
             path: "companies",
             element: <AdminCompanies />
          },
          {
             path: "articles",
             element: <AdminArticles />
          },
          {
             path: "meditations",
             element: <AdminMeditations />
          },
          {
             path: "podcasts",
             element: <AdminPodcasts />
          },
          {
             path: "media",
             element: <AdminMedia />
          },
          {
             path: "corporate-services",
             element: <AdminCorporateServices />
          },
          {
             path: "personal-services",
             element: <AdminPersonalServices />
          },
          {
             path: "testimonials",
             element: <AdminTestimonials />
          },
          {
             path: "leads",
             element: <AdminLeads />
          },
          {
             path: "vip-users",
             element: <AdminVIPUsers />
          },
          {
             path: "vip-content",
             element: <AdminVIPContent />
          }
        ]
      }
    ]
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
